import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardPage from '../components/dashboard'
import AuthPage from '../components/auth'
import Design from '../components/design'
import NotFoundPage from '../components/not-found'

Vue.use(VueRouter)
export default new VueRouter({
  routes: [
    AuthPage,
    DashboardPage,
    Design, // Test class for general ui components,
    NotFoundPage,
    { path: '/', redirect: '/dashboard/customers' }
  ]
})
